







import {Component, Prop, Vue} from 'vue-property-decorator';
import {
	PaymentMethodData,
	WebService,
	CREDIT_ENTRY_METHOD,
	ITokenizeResult
} from '@customer-portal/shared';


@Component({
	components: {}
})
export default class GooglePayButton extends Vue {
	@Prop({required: true})
	locationId!: string;

	@Prop({required: true})
	label!: string;

	@Prop({required: true})
	total!: number;

	paymentRequestConfig: PaymentMethodData | null = null;

	async created() {
		this.paymentRequestConfig = await WebService.getPaymentRequestConfig(this.locationId, CREDIT_ENTRY_METHOD.GOOGLE_PAY);
	}

	async start() {
		if(this.paymentRequestConfig) {
			let request: PaymentRequest;
			if(window.PaymentRequest) {
				request = new PaymentRequest(
					[this.paymentRequestConfig],
					this.getDetails()
				);

				const response = await request.show();
				console.log(response);
				try {
					const signedToken = await WebService.tokenize(this.locationId, CREDIT_ENTRY_METHOD.GOOGLE_PAY, JSON.parse(response.details.paymentMethodData.tokenizationData.token));
					console.log(signedToken);
					await response.complete('success');
					const payload: ITokenizeResult = {
						signedToken: signedToken,
						accountId: null,
						cvv: null,
					};
					this.$emit('payload', payload);
				} catch(error) {
					console.error(error);
					await response.complete('fail');
					this.$emit('error', error);
				}
			} else {
				this.$emit('error', 'Google Pay is not supported in this browser');
				this.$q.dialog({
					title: 'Error',
					message: 'Your Browser does not support payment. Please use Safari or Chrome'
				});
			}
		}
	}

	getDetails() {
		return {
			total: {
				label: this.label,
				amount: {
					value: (this.total / 100).toString(),
					currency: 'USD'
				}
			}
		};
	}

	createButton() {
		const paymentsClient = new (google as any).payments.api.PaymentsClient();
		const button = paymentsClient.createButton({
			buttonColor: 'default',
			buttonType: 'plain',
			buttonSizeMode: 'fill',
			onClick: () => {
				this.start();
			},
		});
		(this.$refs.button as HTMLElement).appendChild(button);
	}

	mounted() {
		if(document.getElementById('google-pay-sdk')) {
			return;
		}
		const src = 'https://pay.google.com/gp/p/js/pay.js';
		const script = document.createElement('script');
		script.setAttribute('src', src);
		script.setAttribute('type', 'text/javascript');
		script.setAttribute('id', 'google-pay-sdk');
		script.onload = () => {
			console.log('Google Pay SDK loaded');
			this.createButton();
		};
		document.head.appendChild(script);
	}

	beforeDestroy() {
		const el = document.getElementById('google-pay-sdk');
		if(el) {
			el.remove();
		}
	}
}
